import { IAppState } from '../../redux';
import { TAnalyticsOfferStatus } from '../../types/analytics';
import { getAnalyticsOfferStatus } from '../../utils';
import { selectIsNewOffer } from '../offer';

export const selectAnalyticsOfferStatus = (state: IAppState): TAnalyticsOfferStatus => {
  const isNewOffer = selectIsNewOffer(state);

  return getAnalyticsOfferStatus(isNewOffer);
};
